<template>
  <div class="home">
    <h1 class="title">Question Pages</h1>
    <nav>
       <router-link :to="`/diffcult`" class="page-link">Diffcult</router-link>
      <ul class="page-grid">
        <li v-for="i in 26" :key="i">
          <router-link :to="`/page/${i}`" class="page-link">Page {{ i }}</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'HomePage'
}
</script>

<style scoped>
.home {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.title {
  font-size: 2.5rem;
  color: #4a90e2;
  margin-bottom: 2rem;
}

.page-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  list-style-type: none;
  padding: 0;
}

.page-link {
  display: block;
  padding: 10px;
  background-color: #4a90e2;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.page-link:hover {
  background-color: #3a7bc8;
}

@media (min-width: 768px) {
  .page-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}
</style>